export function formatParapassQuizType(quizType: string): string {
  if (quizType === "issue") {
    return "standby";
  }

  return quizType;
}

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
